import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Exhibitor } from '../models/exhibitors.model';
import { Injectable } from '@angular/core';
import { Api } from './api/api';

@Injectable()
export class ExhibitorApiService {
    constructor(public http: HttpClient, public api: Api) { }

    public addExhibitor(cmd: Exhibitor): Promise<any> {
        return this.api.post(`exhibitor`, cmd).toPromise();
    }

    public editExhibitor(exhibitorId: string, cmd: Exhibitor) {
        return this.api.patch(`exhibitor/${exhibitorId}`, cmd).toPromise();
    }

    public uploadExhibitorPhoto(exhibitorId: string, file: File) {

        const formData: FormData = new FormData();
        formData.append('file', file);
        return this.api.post(`exhibitor/${exhibitorId}/uploadBranding`, formData).toPromise();
    }

    public getExhibitor(exhibitorId: string): Promise<any> {
        return this.api.get(`exhibitor/${exhibitorId}`).toPromise();
    }

    public getExhibitors(eventId: string): Promise<any> {
        return this.api.get(`exhibitor?eventId=${eventId}`).toPromise();
    }

    public getExhibitorsByTag(eventUuid: string, tags: string[]): Promise<any> {
        return this.api.post(`events/getAllExhibitorsByTagsV2?eventUuid=${eventUuid}`, tags).toPromise();
    }

    public getExhibitorTags(eventUuid: string): Promise<any> {
        return this.api.get(`events/getAllTagsForEvent?eventUuid=${eventUuid}&includeMainEvent=false`).toPromise();
    }

    public addTeamMember(eventId: string, exhibitorId: string, email: string, isMain: boolean) {
        if (isMain) {
            return this.api.post(`exhibitor/main/${eventId}/addTeamMember`, { email: email}).toPromise();
        } else {
            return this.api.post(`exhibitor/${exhibitorId}/addTeamMember`, { email: email}).toPromise();
        }
    }

    public getMainExhibitor(eventId: string): Promise<any> {
        return this.api.get(`exhibitor/main?eventId=${eventId}`).toPromise();
    }

    public getSponsorGroups(eventId: string): Promise<any> {
        return this.api.get(`showcase/groups/?eventId=${eventId}`).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/providers/exhibitors.provider.ts